'use client';

import { useEffect, useState } from 'react';

import { getLocalVariable } from '@services/storage';

import { TagEventType } from '@app-types/tracking';

import { VariationEnum, variationOption, weightedRandom } from '@helpers/abtest-utils';

import useTracking from './use-tracking';

export default function useAbTest(
    localStorageKey: string,
    abTestValue?: string,
    abTestTrackingDescription?: string,
    sendImpressionTracking = true,
) {
    const [abTestVariant, setAbTestVariant] = useState<VariationEnum>(VariationEnum.VARIATION_B);
    const { sendTag } = useTracking();
    function sendTagImp(variant: VariationEnum, sendImpressionTracking: boolean): void {
        setTimeout(() => {
            if (!sendImpressionTracking) return;
            onImpression(
                variant === VariationEnum.VARIATION_A
                    ? `Avec_${abTestTrackingDescription}`
                    : `Sans_${abTestTrackingDescription}`,
            );
        }, 1000);
    }

    const onImpression = (nomClic: string) =>
        sendTag(
            {
                actionClic: 'Impression',
                categorieClic: localStorageKey,
                nomClic,
            },
            TagEventType.IMPRESSION,
        );

    useEffect(() => {
        setVariantStoragAbTest(sendImpressionTracking);
    }, []);

    const setVariantStoragAbTest = (sendImpressionTracking: boolean): VariationEnum | undefined => {
        const isSonde = !!getLocalVariable('sonde');
        if (!abTestValue || isSonde) {
            return;
        }
        const variantStorage: VariationEnum = localStorage.getItem(localStorageKey) as VariationEnum;

        variationOption.VARIATION_A.randomChance = parseInt(abTestValue, 10) ?? 50;
        variationOption.VARIATION_B.randomChance = 100 - parseInt(abTestValue, 10);

        if (variantStorage && variationOption[variantStorage]?.randomChance !== 0) {
            setAbTestVariant(variantStorage);
            sendTagImp(variantStorage, sendImpressionTracking);
            return variantStorage;
        }

        const wrVariation = weightedRandom(variationOption);
        const randomAbTestResult = wrVariation || variationOption.VARIATION_A.key;

        localStorage.setItem(localStorageKey, randomAbTestResult);
        sendTagImp(randomAbTestResult, sendImpressionTracking);

        setAbTestVariant(randomAbTestResult);
        return randomAbTestResult;
    };

    return {
        abTestVariant,
    };
}
